import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { clearFix } from '../styles/theme';
import stylePlaceholders from '../styles/placeholders';
import ImageOrVideo from './ImageOrVideo';
import { linkType, responsiveImageType, responsiveVideoType } from '../propTypes';
import Link from './Link';

const DeferredCard = ({
  aspect, children, classes, className, image, imageClassName, link, ready, title, video,
}) => (
  // Note: the wrapper div here is important because the <Link> component may swap an <a> for a
  // <div> at runtime, and if this component is placed inside a SideScroller (which moves its
  // children elsewhere in the DOM) then React is no longer able to swap over those elements (it
  // throws an Error). The <div> is unchanging so is SideScroller-safe.
  <div className={cn(className, !ready && classes.placeholder)}>
    <Link className={classes.link} link={link}>
      <ImageOrVideo
        aspect={aspect}
        className={cn(imageClassName, classes.image)}
        defaultAlt={title}
        image={image}
        video={video}
      />
      {children}
    </Link>
  </div>
);

DeferredCard.propTypes = {
  aspect: PropTypes.number,
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  image: responsiveImageType,
  imageClassName: PropTypes.string,
  link: linkType,
  ready: PropTypes.bool,
  title: PropTypes.string,
  video: responsiveVideoType,
};

DeferredCard.defaultProps = {
  aspect: 4 / 5,
  children: undefined,
  className: undefined,
  image: undefined,
  imageClassName: undefined,
  link: undefined,
  ready: false,
  title: undefined,
  video: undefined,
};

export default injectSheet({
  link: {
    display: 'block',
    position: 'relative',
    ...clearFix,
    '&, .cms-content &[href]': {
      textDecoration: 'none',
    },
  },
  image: {
    display: 'block',
    width: '100%',
  },
  ...stylePlaceholders({ image: true }),
})(DeferredCard);
